import React, { useEffect, useState } from "react";
import Modal from "components/Models/index";
import folderIcon from "assets/images/fileImage/folderIcon.svg";
import addIcon from "assets/images/fileImage/addIcon.svg";
import Input from "components/Input/index";
import Button from "components/Button/index";
import useScreenMobile from "hooks/useScreen";
import Drawer from "components/Drawer/index";
import useTheme from "hooks/observer";
import RenameFile from "components/RenameFile/index";
import { Item, Folder as IzFolder, File as IzFile } from "@induz/sdk";
import Breadcrumb from "containers/Homepage/Ysafe/table/BreadCrum/index";
import { useToast } from "components/Toaster/index";
import MoveCopyOptions from "containers/Homepage/Ysafe/MoveAndCopyOptions/index";

import "./selectObjectsPins.scss";

const folderName = [];

const PinSelectFileContent = ({
    //   copied,
    handleCancel,
    currentPath,
    fetchData,
    setCurrentPath,
    UUIDArrays,
    selectedFolder,
    checkedRows,
    handleSave,
}) => {

    // Add this function to determine file icons based on extension
    // Simple file icon fallback using emoji or text
    const getFileIcon = (fileName) => {
        const extension = fileName.split(".").pop().toLowerCase();
        switch (extension) {
            case "pdf":
                return "📄";
            case "doc":
            case "docx":
                return "📝";
            case "xls":
            case "xlsx":
                return "📊";
            case "jpg":
            case "jpeg":
            case "png":
                return "🖼️";
            default:
                return "📁"; // Generic file/folder icon
        }
    };
    // Add this state variable
    const [selectedFile, setSelectedFile] = useState(null);





    const theme = useTheme();
    const showToast = useToast();

    const [openModal, setOpenModal] = useState(false);
    const [foldername, setFolderName] = useState("");
    const [folders, setFolders] = useState([...folderName]);
    const [currPath, setCurrPath] = useState([]);
    const [dupCurrentPath, setdupCurrentPath] = useState([]);
    const [selected, setSelected] = useState("");
    const [searchQuery, setSearchQuery] = useState("");
    const [filteredFolders, setFilteredFolders] = useState([]);
    const [showConflictModal, setShowConflictModal] = useState(false);
    const [conflictingItems, setConflictingItems] = useState([]);
    const [pendingActions, setPendingActions] = useState([]);
    const [currentConflictIndex, setCurrentConflictIndex] = useState(0);
    useEffect(() => {
        // Only call getData if currPath changes and no file is selected (i.e., we're in a folder)
        if (!selectedFile) {
            getData();
        }
    }, [currPath, selectedFile]);

    const getData = async () => {
        const formattedPath = currPath?.length === 0 ? "/" : `/${currPath.join("/")}`;
        // console.log("get data is called and Current Path:", formattedPath);

        try {
            const folderInstance = new IzFolder();
            const folder = formattedPath === "/" ? folderInstance.getRoot() : folderInstance.folderWithName(formattedPath);
            const list = await folder.getFolderList(2);

            const foldersOnly = list
                .filter((data) => data instanceof IzFolder)
                .map((data) => ({
                    name: data.getFolderName(),
                    type: "folder"
                }));
            const fileObjects = list
                .filter((data) => data instanceof IzFile)
                .map((data) => ({
                    name: data.getName(),
                    type: "file",
                    fileUuid: data.fileUuId
                }));
            const allItems = [...foldersOnly, ...fileObjects];
            const selectedFolderNames = [];
            if (selectedFolder) {
                selectedFolderNames.push(selectedFolder.name);
                // gives complete path
            }

            if (checkedRows) {
                for (const key of Object.keys(checkedRows)) {
                    if (!key.includes(".")) {
                        selectedFolderNames.push(key);
                        // gives complete path
                    }
                }
            }


            const currentPathString = `/${currentPath.join("/")}`;

            // foldersOnly = foldersOnly.filter((folder) => {
            //     const folderName = folder.name.split("/").pop();
            //     const folderPath = folder.name.substring(0, folder.name.lastIndexOf("/")) || "/";
            //     return !(
            //         selectedFolderNames.includes(folderName) &&
            //         folderPath === currentPathString
            //     );
            // });
            const filteredItems = allItems.filter((item) => {
                return !(
                    selectedFolderNames.includes(item.name) &&
                    formattedPath === currentPathString
                );
            });

            setFolders(filteredItems);
        } catch (error) {
            console.error("Failed to list folders:", error);
        }
    };

    const saveHandler = async () => {
        //   if(currPath[1]==="self" && currPath[0]=="shared"){
        //   const newPath = [...currPath];
        //   newPath.splice(1, 1);
        //   currPath=newPath;
        // }
        const formattedPath = currPath?.length === 0 ? "/" : `/${currPath.join("/")}`;
        try {
            // console.log("Here");
            const temp = new IzFolder();
            const root = temp.getRoot();
            await root.createFolder(formattedPath, foldername);
            showToast("Folder Created Successfully", "success");
            getData(currentPath);
            setOpenModal(false);
            setFolderName("");
        } catch (error) {
            console.error("Failed to create folder:", error);
            setOpenModal(false);
            showToast("Failed to create Folder", "error");
        }
    };

    const cancelHandler = () => {
        setOpenModal(false);
        setFolderName("");
    };

    const searchHandler = (e) => {
        setSearchQuery(e.target.value);
    };

    useEffect(() => {
        const q = searchQuery.trim().toLowerCase();
        setFilteredFolders(
            q
                ? folders.filter((item) => item.name.toLowerCase().includes(q))
                : folders
        );
    }, [folders, searchQuery]);

    const handleFolderClick = (folderName) => {
        setCurrPath((prev) => [...prev, folderName]);
    };

    //   const copyIzFile = async (item, destinationPath, newName) => {
    //     const originalName = item.getName();

    //     const dotIndex = originalName.lastIndexOf(".");
    //     const extension = dotIndex !== -1 ? originalName.slice(dotIndex) : "";
    //     const finalName = newName.includes(".") ? newName : `${newName}${extension}`;
    //     await item.copy(destinationPath, finalName);
    //     showToast("Copy successfully completed", "success");
    //   };

    //   const copyIzFolder = async (item, destinationPath, newName) => {
    //     await item.copy(destinationPath, newName);
    //     showToast("Copy Folder successfully completed", "success");
    //   };

    const moveCopyHandler = async (destinationPath) => {
        // console.log("destinationPath in moveCopyHandler:", destinationPath);
        try {
            const item = await Item.getItem(destinationPath, false);
            // console.log("Item in moveCopyHandler:", item);
            // console.log("Item type:", typeof item, "Constructor:", item.constructor?.name);
            let uuid = null;
            if (item.folderUuId) {
                // This is a folder
                // Convert numeric array to string UUID if needed
                // uuid = convertToUuidString(item.folderUuId);
                // Or use the raw value if your handleSave can work with it
                uuid = item.folderUuId;
                // console.log("Found folder UUID:", uuid);
            }
            else if (item.fileUuId) {
                // This is a file
                uuid = item.fileUuId;
                // console.log("Found file UUID:", uuid);
            }
            else {
                console.error("Cannot determine item type:", item);
                showToast("Invalid item type", "error");
                return;
            }
            // console.log("Final uuid and about to do handlesave", uuid);
            // Convert uuid (bytes/array) to hex string if it's an array or Uint8Array
            let hexUuid = uuid;
            if (Array.isArray(uuid) || uuid instanceof Uint8Array) {
                hexUuid = Array.from(uuid)
                    .map((b) => b.toString(16).padStart(2, "0"))
                    .join("");
            }
            handleSave(hexUuid);
            //   if (copied) {
            //     if (item instanceof IzFile) {
            //       if(currentPath.length===1 && currentPath[0]==="shared"){
            //          item.setFileName(item.getFileUuId()) ;
            //       }
            //       await copyIzFile(item, destinationPath, finalName);
            //     } else if (item instanceof IzFolder) {
            //         if(currentPath.length===1 && currentPath[0]==="shared"){
            //           // const name=item.get_path();
            //          item.setFolderName(item.getUuId()) ;
            //       }
            //       await copyIzFolder(item, destinationPath, finalName);
            //     }
            //   } else {
            //     await item.move(destinationPath, finalName);
            //     showToast("Move successfully completed", "success");
            //   }
        } catch (error) {
            showToast("selecting File/Folder failed", "error");
        }
    };
    const moveHandler = async () => {
        // console.log("Move Handler called with currentPath:", currPath);
        const destinationPath = currPath.length > 0 ? "/" + currPath.join("/") : "/";

        // If a file is selected, use its UUID
        if (selectedFile && selectedFile.type === "file") {
            try {
                // If we have a file UUID stored, use it directly
                if (selectedFile.fileUuid) {
                    // Convert UUID if needed (as you did in moveCopyHandler)
                    let hexUuid = selectedFile.fileUuid;
                    if (Array.isArray(hexUuid) || hexUuid instanceof Uint8Array) {
                        hexUuid = Array.from(hexUuid)
                            .map((b) => b.toString(16).padStart(2, "0"))
                            .join("");
                    }
                    handleSave(hexUuid);
                    return;
                }
                const normalizePath = (basePath, fileName) => {
                    if (basePath.endsWith("/")) {
                        return `${basePath}${fileName}`;
                    }
                    return `${basePath}/${fileName}`;
                };

                // Otherwise get the file item and extract UUID
                const filePath = normalizePath(destinationPath, selectedFile.name);
                const item = await Item.getItem(filePath, false);
                if (item && item.fileUuId) {
                    let hexUuid = item.fileUuId;
                    if (Array.isArray(hexUuid) || hexUuid instanceof Uint8Array) {
                        hexUuid = Array.from(hexUuid)
                            .map((b) => b.toString(16).padStart(2, "0"))
                            .join("");
                    }
                    handleSave(hexUuid);
                } else {
                    showToast("Cannot get file UUID", "error");
                }
            } catch (error) {
                showToast("Selecting file failed", "error");
                console.error(error);
            }
        }
        // If a folder is selected or we're at the root, use the current directory
        else {
            try {
                await moveCopyHandler(destinationPath);
            } catch (error) {
                showToast("Failed to select folder", "error");
            }
        }
    };


    // const moveHandler = async () => {
    //     console.log("Move Handler called with currentPath:", currPath);
    //     // const sourcePath = currentPath.length > 0 ? "/" + currentPath.join("/") : "/";

    //     const destinationPath = currPath.length > 0 ? "/" + currPath.join("/") : "/";
    //     // const conflicts = [];
    //     // const actions = [];
    //     // console.log("UUIDARRAYS",UUIDArrays);
    //     // console.log("Currentpath[0]",currentPath[0]);
    //     // console.log("CHecked Rows,Selected Folder",checkedRows,selectedFolder);
    //     // if (checkedRows) {
    //     //     const keys = Object.keys(checkedRows);
    //     //     for (let i = 0; i < keys.length; i++) {

    //     //         let key = keys[i];
    //     //         if (currentPath.length === 1 && currentPath[0] === "shared") {
    //     //             key = UUIDArrays[i];
    //     //             // console.log("KEy in dnlafldsaf",UUIDArrays[i]);
    //     //         }
    //     //         const fullPath = destinationPath + "/" + key;
    //     //         try {
    //     //             const exists = await Item.getItem(fullPath, false);
    //     //             if (exists) {
    //     //                 conflicts.push(key);
    //     //                 actions.push({ source: sourcePath + "/" + key, originalName: key });
    //     //             } else {
    //     //                 await moveCopyHandler(sourcePath + "/" + key, destinationPath, key, key);
    //     //             }
    //     //         } catch (error) {
    //     //             await moveCopyHandler(sourcePath + "/" + key, destinationPath, key, key);
    //     //         }
    //     //     }
    //     // } else if (selectedFolder) {
    //     // console.log("Selected Folder:", selectedFolder);
    //     // const fullPath = destinationPath + "/" + selectedFolder.name;
    //     try {
    //         // const exists = await Item.getItem(fullPath, false);
    //         // if (exists) {
    //         //   conflicts.push(selectedFolder.name);
    //         //   // if (currentPath.length === 1 && currentPath[0] === "shared"){
    //         //   //   actions.push({ source: sourcePath + "/" + selectedFolder.uuids, originalName: selectedFolder.name });
    //         //   // }
    //         // //   actions.push({ source: sourcePath + "/" + selectedFolder.name, originalName: selectedFolder.name });
    //         // } else {
    //         //   if (currentPath.length === 1 && currentPath[0] === "shared"){
    //         //   await moveCopyHandler(sourcePath + "/" + selectedFolder.uuids, destinationPath, selectedFolder.name, selectedFolder.name);
    //         //   }
    //         //   else await moveCopyHandler(sourcePath + "/" + selectedFolder.name, destinationPath, selectedFolder.name, selectedFolder.name);
    //         await moveCopyHandler(destinationPath);
    //         // }
    //     } catch (error) {
    //         // console.error("Error moving/copying selected folder:", error);
    //         showToast("Failed to move/copy selected folder", "error");
    //     }
    //     // }

    //     // if (conflicts.length > 0) {
    //     //     setConflictingItems(conflicts);
    //     //     setPendingActions(actions);
    //     //     setCurrentConflictIndex(0);
    //     //     setShowConflictModal(true);
    //     // } else {
    //     //     fetchData(currentPath);
    //     //     handleCancel();
    //     // }
    // };

    const handleRename = async (newName) => {
        // Changed: Skip if no newName, proceed with rename if provided
        if (newName && pendingActions[currentConflictIndex]) {
            try {
                await moveCopyHandler(
                    pendingActions[currentConflictIndex].source,
                    currPath.length > 0 ? "/" + currPath.join("/") : "/",
                    newName,
                    pendingActions[currentConflictIndex].originalName
                );
            } catch (error) {
                showToast("Failed to rename and move/copy item", "error");
            }
        }

        // Changed: Advance to next conflict or finalize
        const nextIndex = currentConflictIndex + 1;
        if (nextIndex < conflictingItems.length) {
            setCurrentConflictIndex(nextIndex);
        } else {
            setShowConflictModal(false);
            setConflictingItems([]);
            setPendingActions([]);
            fetchData(currentPath);
            handleCancel();
        }
    };

    const handleModalClose = () => {
        // Changed: Skip current conflict and move to next or finalize
        const nextIndex = currentConflictIndex + 1;
        if (nextIndex < conflictingItems.length) {
            setCurrentConflictIndex(nextIndex);
        } else {
            setShowConflictModal(false);
            setConflictingItems([]);
            setPendingActions([]);
            fetchData(currentPath);
            handleCancel();
        }
    };

    const trimmedSearch = searchQuery.trim();
    const listForDisplay = trimmedSearch ? filteredFolders : folders;
    const showSearchNoResults = trimmedSearch.length > 0 && listForDisplay.length === 0;

    return (
        <div className={`moveFileContainer ${theme === "light" ? "" : "moveFileContainerDark"}`}>
            <div className="folderFile">
                <div className="selectedFileName">
                    <Breadcrumb currentPath={currPath} setCurrentPath={setCurrPath} allFiles dupCurrentPath={dupCurrentPath} setdupCurrentPath={setdupCurrentPath} />
                </div>
                <div className="inputBox">
                    <Input
                        placeholder="Search "
                        searchIconBool={true}
                        value={searchQuery}
                        onChange={searchHandler}
                        left="20px"
                    />
                </div>
            </div>
            <div className="folderNamesContainer">
                {listForDisplay.length > 0 ? (
                    listForDisplay.map((item, index) => (
                        <div
                            className={`folderName ${selected === item.name ? "selected" : ""}`}
                            key={index}
                            onDoubleClick={
                                ()=>{
                                    if (item.type === "folder") {
                                        handleFolderClick(item.name);
                                    } else {
                                        setSelected(item.name);

                                        setSelectedFile(item);
                                    }
                                }
                            }
                            onClick={() => {
                                setSelected(item.name);
                                if (item.type === "folder") {
                                    // Don't navigate on single click for folders, just select
                                } else {
                                    // For files, store the selected file information
                                    setSelectedFile(item);
                                }
                            }}
                        >
                            <img
                                src={item.type === "folder" ? folderIcon : getFileIcon(item.name)}
                                alt={item.type === "folder" ? "Folder" : "File"}
                            />
                            <p>{item?.name}</p>
                        </div>
                    ))
                ) : showSearchNoResults ? (
                    <div className="moveFileSearchEmpty" role="status">
                        No matching items
                    </div>
                ) : null}
            </div>
            <div className="MoveFileFooter">
                <div className="footer" onClick={() => setOpenModal(true)} style={{ cursor: "pointer" }}>
                    <img src={addIcon} alt="Add Folder" />
                    <p>Create New Folder</p>
                </div>
                <Button
                    title={selectedFile ? "Choose this file" : "Choose this folder"}
                    type="violet"
                    width="32%"
                    onClick={moveHandler}
                />
            </div>

            {openModal && (
                <RenameFile
                    submitBtnText="Create"
                    label="Create Folder"
                    placeholder="Folder name"
                    value={foldername}
                    onChange={(e) => {
                        const newValue = e.target.value.replace(/[^a-zA-Z0-9 _-]/g, "");

                        setFolderName(newValue);
                    }}
                    handleSave={saveHandler}
                    handleCancel={cancelHandler}
                    heading="Create Folder"
                    wrapWidth="100%"
                    disabled={foldername.length === 0}
                    mockClass={"ysafe"}
                />
            )}

            {showConflictModal && (
                <MoveCopyOptions
                    isOpen={showConflictModal}
                    onClose={handleModalClose}
                    onRename={handleRename}
                    fileName={conflictingItems[currentConflictIndex]}
                    destinationPath={currPath.length > 0 ? "/" + currPath.join("/") : "/"}
                    key={conflictingItems[currentConflictIndex]} // Changed: Add key to force re-render
                />
            )}
        </div>
    );
};

const PinSelectFile = ({
    //   copied = true,
    handleCancel,
    rowData,
    selectedModal,
    currentPath,
    fetchData,
    setCurrentPath,
    selectedFolder,
    checkedRows,
    UUIDArrays,
    handleSave,
    count
}) => {
    const isMobile = useScreenMobile({ size: 992 });

    //   const heading = copied
    //     ? selectedModal === "copy"
    //       ? `${count || 0} Files to Copied`
    //       : `Copied “${rowData?.name}”`
    //     : selectedModal === "moveTo"
    //     ? `Move ${count || 0} Files to`
    //     : `Moved “${rowData?.name}”`;
    const heading = "Files to be choosen";
    return isMobile ? (
        <Drawer
            showFooter={false}
            showCross={true}
            heading={heading}
            isVisible={true}
            handleCancel={handleCancel}
        >
            <PinSelectFileContent
                checkedRows={checkedRows}
                // copied={copied}
                handleCancel={handleCancel}
                currentPath={currentPath}
                fetchData={fetchData}
                UUIDArrays={UUIDArrays}
                setCurrentPath={setCurrentPath}
                selectedFolder={selectedFolder}
                handleSave={handleSave}
            />
        </Drawer>
    ) : (
        <Modal
            showFooter={false}
            showCross={true}
            heading={heading}
            handleCancel={handleCancel}
            isVisible={true}
        >
            <PinSelectFileContent
                checkedRows={checkedRows}
                // copied={copied}
                UUIDArrays={UUIDArrays}
                handleCancel={handleCancel}
                currentPath={currentPath}
                fetchData={fetchData}
                setCurrentPath={setCurrentPath}
                selectedFolder={selectedFolder}
                handleSave={handleSave}
            />
        </Modal>
    );
};

export default PinSelectFile;
